<template>
  <div class="col-12 px-0">
    <ArticlesFields
      with-image
      v-model="draft.steps.secondAndFifthArticles.article2"
      id="2"
      class="mt-3 mb-3 pb-3"
      :highlight-fields="highlightFields"
      @input="v => updated('article2', v)"
      disable-private
      use-bullets="marketing"
    />
    <ArticlesFields
      with-image
      v-model="draft.steps.secondAndFifthArticles.article3"
      id="3"
      class="mb-3 pb-3"
      :highlight-fields="highlightFields"
      @input="v => updated('article3', v)"
      disable-private
      use-bullets="marketing"
    />
    <ArticlesFields
      with-image
      v-model="draft.steps.secondAndFifthArticles.article4"
      id="4"
      class="mb-3 pb-3"
      :highlight-fields="highlightFields"
      @input="v => updated('article4', v)"
      disable-private
      use-bullets="marketing"
    />
    <ArticlesFields
      with-image
      v-model="draft.steps.secondAndFifthArticles.article5"
      id="5"
      class="mb-4 pb-4"
      :highlight-fields="highlightFields"
      @input="v => updated('article5', v)"
      disable-private
      use-bullets="marketing"
    />
  </div>
</template>

<script>
import ArticlesFields from '../ArticlesFields'

export default {
  name: 'MostReadOnTellimerSecondAndFifthArticlesStep',

  components: {
    ArticlesFields,
  },

  props: {
    draft: {
      type: Object,
      required: true,
    },
    highlightFields: {
      required: true,
      type: Boolean,
    },
  },

  methods: {
    updated (part, val) {
      const data = this.draft
      if (!data.steps.secondAndFifthArticles) {
        data.steps.secondAndFifthArticles = {}
      }
      data.steps.secondAndFifthArticles[part] = val
      this.$emit('update', data)
    }
  }
}
</script>

